//AdminFrontend/src/admin_ui/services/adminPosInventoryApi.js
import adminApi from "./adminApiClient";

export async function listPosInventorySubmissions(params) {
  const res = await adminApi.get("/api/admin/pos/inventory/submissions", { params });
  return res.data;
}

export async function approvePosInventorySubmission(id, payload) {
  const res = await adminApi.post(`/api/admin/pos/inventory/submissions/${id}/approve`, payload);
  return res.data;
}

export async function rejectPosInventorySubmission(id, payload) {
  const res = await adminApi.post(`/api/admin/pos/inventory/submissions/${id}/reject`, payload);
  return res.data;
}
